import React, { useState } from 'react';

interface KohoContextProps {
  employees: any;
  projects: any;
}

export const KohoContext = React.createContext<KohoContextProps>(
  {} as KohoContextProps
);

export const KohoContextProvider = props => {
  const [koho] = useState(props.koho);

  return (
    <KohoContext.Provider value={koho}>{props.children}</KohoContext.Provider>
  );
};
